import React, { useState, useRef, useEffect } from 'react';
import './ProgramaMG.css';

import imgEstructura  from '../../assets/programa-mg/estructura-orden.png';
import imgConocimiento from '../../assets/programa-mg/conocimiento-ser.png';
import imgVision  from '../../assets/programa-mg/desarrollo-vision.png';
import img21  from '../../assets/programa-mg/21.jpg';
import img22 from '../../assets/programa-mg/22.jpg';
import img23 from '../../assets/programa-mg/23.jpg';
import img31 from '../../assets/programa-mg/31.jpg';
import img32 from '../../assets/programa-mg/32.jpg';
import img33 from '../../assets/programa-mg/33.jpg';

const etapas = [
  {
    numero: '01',
    titulo: 'Inicial',
    subetapas: [
      {
        titulo: 'Estructura y orden del proceso',
        descripcion: 'Establecimiento de las bases metodológicas del programa, definiendo el marco de trabajo y las herramientas que guiarán el proceso.',
        image: imgEstructura,
      },
      {
        titulo: 'Conocimiento del ser & estado inicial de consciencia',
        descripcion: 'Autoconocimiento profundo y evaluación del estado mental inicial del deportista como punto de partida.',
        image: imgConocimiento,
      },
      {
        titulo: 'Desarrollo de la visión – proceso de limpieza emocional',
        descripcion: 'Clarificación de objetivos personales y deportivos, acompañada de un proceso de gestión y liberación emocional.',
        image: imgVision,
      },
    ],
  },
  {
    numero: '02',
    titulo: 'Desarrollo',
    subetapas: [
      {
        titulo: 'Estado avanzado de la consciencia del presente',
        descripcion: 'Entrenamiento en mindfulness y presencia plena en el momento actual para optimizar el rendimiento.',
        image: img21,
      },
      {
        titulo: 'Desarrollo de la identidad del ser',
        descripcion: 'Construcción y fortalecimiento de la identidad deportiva como base del rendimiento sostenido.',
        image: img22,
      },
      {
        titulo: 'Incorporación real de la importancia del cuerpo',
        descripcion: 'Integración consciente de la conexión mente-cuerpo como factor determinante en el rendimiento.',
        image: img23,
      },
    ],
  },
  {
    numero: '03',
    titulo: 'Consolidación',
    subetapas: [
      {
        titulo: 'Apertura al rendimiento deportivo',
        descripcion: 'Aplicación práctica de todas las habilidades mentales trabajadas en situaciones reales de competencia.',
        image: img31,
      },
      {
        titulo: 'Resultado deportivo',
        descripcion: 'Optimización integral del rendimiento en competencia a través de las herramientas del programa.',
        image: img32,
      },
      {
        titulo: 'Seguimiento',
        descripcion: 'Monitoreo continuo del proceso y ajustes metodológicos para mantener el avance del deportista.',
        image: img33,
      },
    ],
  },
];

const ProgramaMG = () => {
  const [activeEtapa, setActiveEtapa] = useState(null);
  const contentRefs = useRef([]);

  const toggle = (i) => setActiveEtapa(activeEtapa === i ? null : i);

  /* Animación de apertura suave con height */
  useEffect(() => {
    contentRefs.current.forEach((el, i) => {
      if (!el) return;
      if (activeEtapa === i) {
        el.style.maxHeight = el.scrollHeight + 'px';
        el.style.opacity   = '1';
      } else {
        el.style.maxHeight = '0px';
        el.style.opacity   = '0';
      }
    });
  }, [activeEtapa]);

  return (
    <div className="programa-page">

      {/* ── HEADER ── */}
      <header className="programa-header">
        <div className="programa-header__inner">
          <h1 className="programa-header__title">Programa MG</h1>
          <p className="programa-header__subtitle">
            Metodología Mente Ganadora — Proceso de desarrollo mental deportivo
          </p>
        </div>
        <div className="programa-header__bar" />
      </header>

      {/* ── ETAPAS ── */}
      <section className="programa-section">
        <div className="etapas-list">
          {etapas.map((etapa, i) => (
            <div key={i} className={`etapa ${activeEtapa === i ? 'etapa--open' : ''}`}>

              {/* Cabecera clickeable */}
              <button
                className="etapa__header"
                onClick={() => toggle(i)}
                aria-expanded={activeEtapa === i}
              >
                <div className="etapa__header-left">
                  <span className="etapa__numero">Etapa {etapa.numero}</span>
                  <h2 className="etapa__titulo">{etapa.titulo}</h2>
                </div>
                <span className={`etapa__chevron ${activeEtapa === i ? 'etapa__chevron--up' : ''}`}>
                  ▼
                </span>
              </button>

              {/* Subetapas — altura animada */}
              <div
                ref={(el) => (contentRefs.current[i] = el)}
                className="etapa__body"
              >
                <div className="subetapas-grid">
                  {etapa.subetapas.map((sub, j) => (
                    <div
                      key={j}
                      className="sub-card"
                      style={{ animationDelay: `${j * 0.08}s` }}
                    >
                      <div className="sub-card__img">
                        {sub.image ? (
                          <img src={sub.image} alt={sub.titulo} />
                        ) : (
                          <div className="sub-card__placeholder">
                            <span>{etapa.numero}</span>
                          </div>
                        )}
                      </div>
                      <div className="sub-card__body">
                        <h4 className="sub-card__titulo">{sub.titulo}</h4>
                        <p className="sub-card__desc">{sub.descripcion}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default ProgramaMG;
